@use '../style.scss' as *;
.container {
	position: absolute;
	bottom: 10px;
	left: 10px;
	z-index: 5;
	pointer-events: none;
	user-select: none;
	border-radius: 2px;
	width: calc(100% - 20px);
	border: 1px solid #d8e0e8;
	background: #fff;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
	font-family: 'Ringside', sans-serif;
	font-size: 16px;
	line-height: 100%;
	display: flex;
	flex-direction: column;
	// @media only screen and (min-width: $mida-tall) {
	// 	top: 10px;
	// 	right: 10px;
	// 	bottom: unset;
	// 	left: unset;
	// 	width: 100%;
	// 	max-width: 250px;
	// }
	header {
		font-weight: 700;
		text-align: center;
		background-color: #d8e0e8;
		padding: 10px;
	}
	p {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		margin-inline: 10px;
		padding-block: 10px;
		&:first-of-type {
			border-bottom: 1px solid #d8e0e8;
		}
		.bullet {
			display: inline-block;
			width: 12px;
			height: 12px;
			border-radius: 50%;
			background-color: #000;
			margin-right: 5px;
		}
	}
}
